import { WarehouseNameRotation } from "components/animations";
import { FillImage } from "components/images";
import React from "react";
import Balancer from "react-wrap-balancer";
import { MediaAccordion } from "ui/accordion";
import { TextTitle } from "ui/text";
import accordion1 from "../../../../public/assets/solutions/retail/accordion-1.png";
import accordion2 from "../../../../public/assets/solutions/retail/accordion-2.png";
import accordion3 from "../../../../public/assets/solutions/retail/accordion-3.png";
import accordion4 from "../../../../public/assets/solutions/retail/accordion-4.png";

export function MediaNetworkFeatures() {
  return (
    <>
      <TextTitle
        theme="dark"
        size="lg"
        align="center"
        title={
          <Balancer>
            Build your retail media network on <WarehouseNameRotation isCentered hasGenericWarehouse />
          </Balancer>
        }
        description="The building blocks you need to activate, monetize, and measure highly personalized onsite and offsite audiences, using the data already in your cloud data warehouse."
        maxW="650px"
        mt={{ base: "huge", md: "hugest" }}
        mb={{ base: "big", md: "huge" }}
      />

      <MediaAccordion
        theme="dark"
        variant="dynamic"
        items={[
          {
            title: "Build unique audiences for every advertiser, without a line of code",
            content:
              "Offer advertisers highly personalized custom audiences using a visually audience builder that adopts the schema of your data warehouse.",
            media: (
              <FillImage
                src={accordion1}
                alt='An abstract version of the Hightouch UI showing an Audience being defined. The matching criteria are that there is at least one "High" product propensity score and at least one pet that is a dog.'
              />
            ),
          },
          {
            title: "Enable onsite targeting on any data point",
            content:
              "Enable advertisers to serve onsite ads to site visitors based on customer attributes and behavioral data unique to your business.",
            media: (
              <FillImage
                src={accordion2}
                alt='Abstract illustration showing showing three product listings. The middle product listing includes a "Sponsored" tag on it.'
              />
            ),
          },
          {
            title: "Expand to 50+ offsite channels",
            content:
              "Instantly integrate with every major paid social platform, DSP, and CTV provider to expand your media offering.",
            media: (
              <FillImage
                src={accordion3}
                alt="Abstract illustration of a data warehouse surrounded by logos from tools like TikTok, Snapchat, The Trade Desk, AWS, Google Ads, Google Display & Video 360, Reddit, and Facebook."
              />
            ),
          },
          {
            title: "Close the loop with attribution and incrementality testing",
            content: "Prove the value of your advertiser’s media investments with measurement data that you own.",
            media: (
              <FillImage
                src={accordion4}
                alt="Hightouch UI interface showing a table with three columns titled Campaign / Ad Set, Spend, and ROAS. The table has three rows representing three campaigns, all indicating increases in spend and ROAS."
              />
            ),
          },
        ]}
      />
    </>
  );
}
